<template>
  <div class="thumb portrait">
    <a href="#" @click.prevent="goDetail(cellInfo)">
      <div class="thumb-image">
        <img v-lazy="getLazyLoadingImageObject()" class="thumb-img" :alt="altTitle"/>
<!--        <img :src="getResizeImage()" class="thumb-img" alt=""/>-->
        <div v-if="hasProgress" class="cell-progress">
          <span class="gradation-blue" :style="'width:' + Number(progress) * 100 + '%;'"></span>
        </div>
        <div class="tag-top tag-list" v-top-tag-list="topTagList"></div>
        <div class="tag-bottom tag-list" v-if="hasBottomTagList" v-bottom-tag-list="bottomTagList"></div>
        <age-limits :target-age="targetAge" :age-tag="ageTag"/>
        <div :class="adultDimClass"></div>
      </div>
      <div class="sub-title">
        <div v-if="hasRank" class="sub-left">
          <div class="num">{{ rank }}</div>
        </div>
        <div class="sub-right"
             v-title-list="{'titleList': titleList,
                            'searchWord': searchWord,
                            'cellType': 'portrait',
                            'callback': loaded
                            }">
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import _ from 'lodash'
import shave from 'shave'
import AgeLimits from '@/components/model/AgeLimits'
import { bottomTagList, titleList, topTagList } from '@/common/resources/directives'
import CellMixIn from '@/mixins/cell.mixin'
export default {
  name: 'PortraitCell',
  mixins: [
    CellMixIn
  ],
  directives: {
    titleList,
    topTagList,
    bottomTagList
  },
  components: {
    AgeLimits
    // TagIcon
  },
  props: {
    cellInfo: {
      type: Object
    },
    thumbnailInfo: {
      type: Object
    },
    searchWord: {
      type: String
    }
  },
  computed: {
    altTitle () {
      let title = ''
      _.get(this.cellInfo, 'title_list', []).forEach((titleItem) => {
        title += ' ' + titleItem.text
      })
      return title
    }
  },
  methods: {
    loaded (el) {
      this.$nextTick(() => {
        _.forEach(el.querySelectorAll('.line1'), (line1El) => {
          shave(line1El, 28)
        })
      })
    }
  }
}
</script>

<style scoped>
  .portrait{
    position: relative;
    float: left;
    width: 240px;
  }

  .swiper-silde .portrait{
    margin-top: 50px;
  }

  .portrait:last-child{
    margin-right: 0;
  }

  .portrait .thumb-image{
    position: relative;
    width: 240px;
    height: 346px;
    overflow: hidden;
    will-change: transform;
    transform: translateZ(0);
    /*border: 1px solid rgba(168, 168, 168, .15);*/
    /*-webkit-background-clip: padding-box; !* for Safari *!*/
    /*background-clip: padding-box; !* for IE9+, Firefox 4+, Opera, Chrome *!*/
    /*background-image: url(../../../assets/images/common/no-movie.png);*/
    /*background-size: 100% auto;*/
    /*background-position: center*/
  }

  .portrait .thumb-image .thumb-img{
    width: 100%;
  }

  .portrait .thumb-image.discount .thumb-bottom-left{
    bottom: 56px;
  }

  .portrait .thumb-image .discount-layer{
    position: absolute;
    bottom: 0;
    left: 0;
    height: 52px;
    width: calc(100% - 12px);
    background: rgba(42, 42, 42, .9);
    line-height: 52px;
    padding-left: 12px;
  }

  .portrait .thumb-image .discount-layer .price01{
    font-size: 16px;
    color: #888888;
    margin-right: 5px;
    font-weight: 400;
    font-style: normal;
    text-decoration: line-through;
  }

  .portrait .thumb-image .discount-layer .price02{
    font-size: 20px;
    color: #fff;
    font-weight: 700;
    font-style: normal;
  }

  .portrait .thumb-image .dim-19{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    text-indent: -9999px;
    background: url(../../../assets/images/common/tag-movie-19.png) no-repeat center rgba(0, 0, 0, .8);
  }

  .portrait strong{
    font-size: 16px;
    color: #a5a5a5;
    line-height: 1.38;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 0 0 2px;
    display: block;
    font-weight: 400;
  }

  .portrait strong.multi-line{
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    word-wrap: break-word;
    white-space: normal;
    height: 44px;
  }

  .portrait span{
    font-size: 14px;
    color: #666;
    line-height: 1.29;
    margin: 0 0 4px;
    display: block;
  }
  .week6 {
    font-size: 14px;
    line-height: 22px;
    color: #1351f9;
  }
</style>
